///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.dashboard = abcsetup.dashboard || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.dashboard.consumer_rfp_vendor = {
    init() {
        this.rfp.init();
    },

    ///////////////////////////////////////////////////////////////////////////////////////////////////
    //
    //  RFP Methods
    //
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    rfp: {
        init() {
            abcsetup.dashboard.common.vendor.init();
        },
    },
}
